import { render, staticRenderFns } from "./MyNewLogin.vue?vue&type=template&id=1c928e45&"
import script from "./MyNewLogin.vue?vue&type=script&lang=js&"
export * from "./MyNewLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports